import React, { useState } from "react";
import { FormFieldSet } from "../../../../../components";
import { CHECKBOXLIST_PROPS, PropsTable } from "./Props/Props";

const CATEGORIES = {
  core: { label: "Core", color: "#EFF6FF", textColor: "#1D4ED8" },
  display: { label: "Display", color: "#F0FDF4", textColor: "#15803D" },
  behavior: { label: "Behavior", color: "#FFFBEB", textColor: "#B45309" },
};


const CheckboxList = () => {
  const [checkboxValues, setCheckboxValues] = useState([]);
  const handleCheckboxChange = (selectedValues) => {
    setCheckboxValues(selectedValues);
  };

  const [checkboxMultipleValues, setCheckboxMultipleValues] = useState([]);
  const handleCheckboxMultipleChange = (selectedValues) => {
    setCheckboxMultipleValues(selectedValues);
  };

  const [checkboxDefaultSelectValues, setCheckboxDefaultSelectValues] =
    useState(["2"]);
  const handleCheckboxDefaultSelectChange = (selectedValues) => {
    setCheckboxDefaultSelectValues(selectedValues);
  };

  return (
    <div>
      <div className="grid grid-cols-4 gap-5 my-5 mb-30">
        <div>
          <FormFieldSet
            type="checkbox"
            size="md"
            title="Check One"
            placeholder="Enter Zip Code"
            options={[
              { label: "Active", value: "1" },
              {
                label: "InActive",
                value: "2",
              },
            ]}
            values={checkboxValues}
            onChange={handleCheckboxChange}
            //multiple
          />
        </div>
        <div>
          <FormFieldSet
            type="checkbox"
            size="md"
            title="Check Multiple"
            placeholder="Enter Zip Code"
            options={[
              { label: "Active", value: "1" },
              {
                label: "InActive",
                value: "2",
              },
            ]}
            values={checkboxMultipleValues}
            onChange={handleCheckboxMultipleChange}
            multiple
          />
        </div>
        <div>
          <FormFieldSet
            type="checkbox"
            size="md"
            title="Check Default Select"
            placeholder="Enter Zip Code"
            options={[
              { label: "Active", value: "1" },
              {
                label: "InActive",
                value: "2",
              },
            ]}
            values={checkboxDefaultSelectValues}
            onChange={handleCheckboxDefaultSelectChange}
            multiple
          />
        </div>
      </div>

      <PropsTable
        data={CHECKBOXLIST_PROPS}
        title="checkbox — Props Reference"
        typeLabel='type="checkbox"'
        categories={CATEGORIES}
        />
    </div>
  );
};

export default CheckboxList;
